(function ($) {

	'use strict';

	//usage: $('[id^="QUERYCONF-PRODUCTS-"]').shopPreview();

	jQuery.fn.shopPreview = function () {

		var $preview = $(this);
		var queryConf;
		try {
			queryConf = JSON.parse($preview.text());
		} catch (error) {
			return false;
		}


		$.ajax({
			type: 'GET',
			cache: true,
			dataType: 'json',
			url: queryConf.url,
			success: function (result) {
				// container
				var $container = $('<div><div class="articles"></div><div class="loadbutton_container"><a href="' + queryConf.knotUrl + '" class="morebutton_rounded buttoncolor-bw">Mehr anzeigen</a></div></div>');
				$container.attr('id', $preview.attr('id').replace('QUERYCONF-', ''));

				result.records.forEach(function (record) {
					var $prodTpl = $($.morejs_options.templates.shopPreviewProduct);
					$prodTpl.find('h3').text(record.prodName);
					$prodTpl.find('.prodDesc').html(record.prodDesc);
					$prodTpl.find('a').attr('href', record.prodUrl);

					if (record.img !== null) {
						$prodTpl.find('img').attr('src', record.img);
					} else {
						$prodTpl.find('img').remove();
					}

					$container.find('.articles').append($prodTpl);
				});

				$preview.replaceWith($container);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error('shopPreview ajax:', jqXHR, textStatus, errorThrown);
			}
		});


	};	//$.fn.shopPreview



}(jQuery)); //(function ( $ )